import { render, staticRenderFns } from "./Anagrafica.vue?vue&type=template&id=666475f1&scoped=true&"
import script from "./Anagrafica.vue?vue&type=script&lang=js&"
export * from "./Anagrafica.vue?vue&type=script&lang=js&"
import style0 from "./Anagrafica.vue?vue&type=style&index=0&id=666475f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666475f1",
  null
  
)

export default component.exports